export default __webpack_public_path__ + "static/media/login.e00efd90.png";